export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "token.worker.aab682d14b83007997ea.worker.js");
}
